"use client"

import { getOrCreateRlUuid } from "@/utils/uuid/rlUUID"
import { useEffect } from "react"

const RLUUID = () => {
  useEffect(() => {
    getOrCreateRlUuid()
  }, [])
  return <></>
}

export default RLUUID
